<template>
    <v-app id="inspire">
        <v-app-bar
            app
            :color="appMainColor"
            clipped-left
        >
            <v-app-bar-nav-icon
                @click.stop="drawer = !drawer"
            >
                <v-icon :color="burgerColor">mdi-menu</v-icon>
            </v-app-bar-nav-icon>
            <v-toolbar-title :class="mainfontClass" @click="home">QMS</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu
                offset-y
            >
                <template v-slot:activator="{ attrs, on }">
                    <v-btn icon v-on="on">
                        <v-icon :color="burgerColor">account_circle</v-icon>
                    </v-btn>
                </template>

                <v-list>
                    <v-list-item>
                        <v-list-item-title>{{ username }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        link
                    >
                        <v-list-item-icon>
                            <v-icon>exit_to_app</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Logout</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-navigation-drawer
            app
            v-model="drawer"
            clipped
            disable-resize-watcher
        >
            <v-list>
                <v-list-item @click="home">
                    <v-list-item-icon>
                        <v-icon>home</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Home</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-group
                    prepend-icon="admin_panel_settings"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Management</v-list-item-title>
                    </template>

                    <v-list-item @click="groups()">
                        <v-list-item-icon>
                            <v-icon>domain</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Groups</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="outlets()">
                        <v-list-item-icon>
                            <v-icon>store</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Outlets</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-group
                    prepend-icon="analytics"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Report</v-list-item-title>
                    </template>

                    <v-list-item @click="smsReport()">
                        <v-list-item-icon>
                            <v-icon>sms</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>SMS</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list>
        </v-navigation-drawer>

        <v-content class="mt-1">
            <slot></slot>
        </v-content>
        <v-footer
            app
            :color="appMainColor"
        >
            <span :class="mainfontClass">Aptsys</span>
            <v-spacer></v-spacer>
            <span :class="mainfontClass">&copy; {{ new Date().getFullYear() }}</span>
        </v-footer>
    </v-app>
</template>

<script>
import axios from 'axios'

export default {
    props: ['username', 'title', 'maincolor', 'mainfontcolor', 'outletid'],
    data: () => ({
        drawer: false,
    }),
    computed: {
        appMainColor() {
            return this.maincolor !== 'none' ? this.maincolor : 'indigo'
        },
        mainfontClass() {
            let c = this.mainfontcolor !== 'none' ? this.mainfontcolor : 'white';
            return c + '--text'
        },
        burgerColor() {
            return this.mainfontcolor !== 'none' ? this.mainfontcolor : 'white';
        }
    },
    methods: {
        home() {
            window.location.href = '/'
        },
        smsReport() {
            window.location.href = '/admin/sms'
        },
        groups() {
            window.location.href = '/groups'
        },
        outlets() {
            window.location.href = '/outlets'
        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Layouts/Admin.vue